/**
 * Returns a copy of `obj` containing only `keys`, skipping any that are absent.
 *
 * The counterpart to omitKeys. Prefer this when building a GraphQL input from a
 * form: the accepted fields are fixed by the schema, so listing them is stable,
 * whereas a list of fields to drop has to be updated every time the query
 * behind the form grows a new one.
 */
export const pickKeys = (obj, keys) => {
  if (!obj) return {};

  return keys.reduce((prev, curr) => {
    if (Object.prototype.hasOwnProperty.call(obj, curr)) {
      prev[curr] = obj[curr];
    }
    return prev;
  }, {});
};
